// extracted by mini-css-extract-plugin
export var cancelButton = "_qv-5";
export var content = "_qv-3";
export var createButton = "_qv-6";
export var drawerContainer = "_qv-0";
export var footer = "_qv-2";
export var header = "_qv-1";
export var orderFormColumn = "_qv-4";